/* eslint-disable max-lines */
import { message as $message } from 'antd'

import useMinPurchaseAmount from '@/modules/distribute/stores/minPurchaseAmount'

import {
    addCar,
    addCarBySku,
    queryCartGoods,
    queryDisStockAndPrice,
    queryCarCount,
    deleteCar,
    updateCarQty,
} from '@/services/cart'

const initialState = {
    data: [],
    pageNum: 1,
    pageSize: 30,
    hasNext: true,
    total: 0,
    loading: false,
    queryOver: false,
    selectedRowKeys: [],
    selectedRows: [],
    addSuccess: false,
}

export default {
    namespace: 'cart',
    state: {
        ...initialState,
    },
    effects: {
        *query({ payload }, { call, put, select }) {
            const response = yield call(queryCartGoods, payload)

            if (response) {
                const { success, message, data, total, hasNext } = response

                if (success) {
                    const cartList = Array.isArray(data) ? data : []

                    yield put({
                        type: 'update',
                        payload: {
                            data: cartList,
                            total,
                            hasNext,
                        },
                    })

                    // 获取供应商的起采金额
                    const supplierCoIds = cartList?.map(v => v.coId)
                    if (supplierCoIds?.length) {
                        useMinPurchaseAmount.getState()?.getSupplierMinPurchaseAmtByCoIds?.({ coIds: supplierCoIds })
                    }

                    const selectedKeys = yield select(state => state.cart.selectedRowKeys)

                    yield put({
                        type: 'updateSelected',
                        payload: selectedKeys,
                    })

                    // 获取价格库存数据=
                    const channelCartIds = Array.isArray(cartList)
                        ? cartList.reduce((list, { cartSkus }) => {
                              return list.concat(cartSkus.map(item2 => item2?.channelCartId))
                          }, [])
                        : []

                    if (channelCartIds.length > 0) {
                        return yield put({
                            type: 'updateCartPrice',
                            payload: {
                                channelCartIds,
                            },
                        })
                    }
                } else {
                    $message.error(message)
                }
            }
        },
        *updateCartPrice({ payload }, { call, put, select }) {
            const priceResponse = yield call(queryDisStockAndPrice, payload)
            const cartList = yield select(state => state?.cart?.data)
            let newCartList = []
            if (priceResponse?.success) {
                const cartListPrices = Array.isArray(priceResponse?.data) ? priceResponse?.data : []

                newCartList = cartList.map(item => {
                    const cartSkus = Array.isArray(item?.cartSkus)
                        ? item?.cartSkus.map(item2 => {
                              const prices = cartListPrices.find(item3 => item3?.channelCartId === item2?.channelCartId)

                              if (prices) {
                                  return {
                                      ...item2,
                                      ...prices,
                                  }
                              }

                              return item2
                          })
                        : []

                    return {
                        ...item,
                        cartSkus,
                    }
                })

                yield put({
                    type: 'update',
                    payload: {
                        data: newCartList,
                    },
                })
            }

            yield put({
                type: 'update',
                payload: {
                    queryOver: true,
                },
            })
            return newCartList
        },
        *count({ payload: _ignorePayload }, { call, put }) {
            const response = yield call(queryCarCount)

            if (response) {
                const { success, message, data } = response
                if (success) {
                    yield put({
                        type: 'update',
                        payload: {
                            total: data,
                        },
                    })
                } else {
                    $message.error(message)
                }
            }
        },
        *add({ payload }, { call, put }) {
            const response = yield call(addCar, payload)

            if (response) {
                const { success, message } = response

                if (success) {
                    $message.success('加入采购车成功')

                    yield put({
                        type: 'count',
                    })

                    return true
                } else {
                    $message.error(message)
                    return false
                }
            }
        },
        *addBySku(values, { call, put }) {
            const { payload, message: userMsg } = values || {}
            const response = yield call(addCarBySku, payload)

            if (response) {
                const { success, message } = response

                if (success) {
                    $message.success(userMsg ? userMsg : '加入采购车成功')

                    yield put({
                        type: 'count',
                    })

                    return true
                } else {
                    $message.error(message)
                    return false
                }
            }
        },
        *delete({ payload }, { call, put, select }) {
            const carItemIds = payload.map(item => item.channelCartId)
            const response = yield call(deleteCar, carItemIds)

            if (response) {
                const { success, message } = response

                if (success) {
                    $message.success('移除成功')

                    yield put({
                        type: 'deleteItem',
                        payload,
                    })

                    const selectedKeys = yield select(state => state.cart.selectedRowKeys)

                    yield put({
                        type: 'updateSelected',
                        payload: selectedKeys,
                    })

                    yield put({
                        type: 'count',
                    })
                } else {
                    $message.error(message)
                }
            }
        },
        *updateItemQty({ payload: { $cartItem, ...rest } }, { call, put, select }, extra) {
            const { rowKey = 'supplierId' } = extra || {}
            const cache = yield select(state => state.cart.data.find(v => v[rowKey] === rest[rowKey]))

            yield put({
                type: 'updateItem',
                payload: rest,
            })

            if (typeof $cartItem.skuQty !== 'number' && $cartItem.skuQty) {
                return
            }

            const response = yield call(updateCarQty, $cartItem)

            if (response) {
                const { success, message } = response

                if (!success) {
                    $message.error(message)

                    yield put({
                        type: 'updateItem',
                        payload: cache,
                    })
                }
            }
        },
    },
    reducers: {
        updateSupplyPartnerStatus(state, { payload }) {
            const { supplierCoId, partnerStatus, isPartner, supplierName } = payload
            let { data } = state
            for (let i = 0; i < data.length; i++) {
                const element = data[i]
                if (String(element.coId) === String(supplierCoId)) {
                    element.partnerStatus = partnerStatus
                    element.isPartner = isPartner
                    if (supplierName) {
                        element.supplierName = supplierName
                    }
                }
            }

            return {
                ...state,
                data,
            }
        },
        update(state, { payload }) {
            return {
                ...state,
                ...payload,
            }
        },

        reset(state, { payload }) {
            return {
                ...initialState,
                ...(payload || {}),
            }
        },

        deleteItem(state, { payload }) {
            if (Array.isArray(payload)) {
                return {
                    ...state,
                    data: state.data
                        .reduce((t, c) => {
                            return t.concat({
                                ...c,
                                cartSkus: c.cartSkus.filter(
                                    v => !payload.some(c1 => c1.channelCartId === v.channelCartId),
                                ),
                            })
                        }, [])
                        .filter(v => Array.isArray(v.cartSkus) && v.cartSkus.length),
                }
            }
        },
        updateItem(state, { payload, extra }) {
            const { rowKey = 'supplierId' } = extra || {}

            if (Array.isArray(payload)) {
                return {
                    ...state,
                    data: state.data.map(v => {
                        const exist = payload.find(v1 => v1[rowKey] === v[rowKey])

                        if (exist) {
                            return {
                                ...v,
                                ...exist,
                            }
                        }

                        return v
                    }),
                }
            }
            return {
                ...state,
                data: state.data.map(v => {
                    if (v[rowKey] === payload[rowKey]) {
                        return {
                            ...v,
                            ...payload,
                        }
                    }

                    return v
                }),
            }
        },

        updateSelected(state, { payload, extra }) {
            const { rowKey = 'supplierId' } = extra || {}

            const selected = state.data.reduce(
                (t, c) => {
                    if (c[rowKey] === payload[rowKey]) {
                        return {
                            selectedRowKeys: t.selectedRowKeys.concat({
                                [rowKey]: c[rowKey],
                                selectedRowKeys: payload.selectedRowKeys,
                            }),
                        }
                    }

                    const existedRowKeys = state.selectedRowKeys.find(v => v[rowKey] === c[rowKey])

                    if (existedRowKeys) {
                        return {
                            [rowKey]: c[rowKey],
                            selectedRowKeys: t.selectedRowKeys.concat(existedRowKeys),
                        }
                    }

                    return t
                },
                {
                    selectedRowKeys: [],
                },
            )

            return {
                ...state,
                selectedRowKeys: selected.selectedRowKeys.filter(v => v.selectedRowKeys.length),
            }
        },
    },
}
